import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { theme } from "@shared/designSystem/theme";
import RemergeApi from "@shared/http/RemergeApi";
import { RemergeAPIProvider } from "@shared/http/remergeApiContext";
import HttpService from "@shared/services/HttpService";
import { TrackingProvider } from "@shared/services/TrackingContext";
import TrackingService, {
  NullTrackingServiceAdapter,
  ProductionTrackingServiceAdapter,
} from "@shared/services/TrackingService";
type AppContextProps = React.PropsWithChildren<{}>;

const httpService = new HttpService(import.meta.env.VITE_API_HOST as string);
const remergeApi = new RemergeApi(httpService);
const trackingService = new TrackingService(
  // need to get the right tokens and put it into env variables
  import.meta.env.VITE_MIXPANEL_ACCESS_TOKEN
    ? new ProductionTrackingServiceAdapter(import.meta.env.VITE_MIXPANEL_ACCESS_TOKEN)
    : new NullTrackingServiceAdapter(),
);

export default function AppContext(props: AppContextProps) {
  return (
    <RemergeAPIProvider value={remergeApi}>
      <TrackingProvider value={trackingService}>
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>{props.children}</StyledEngineProvider>
        </ThemeProvider>
      </TrackingProvider>
    </RemergeAPIProvider>
  );
}
